import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { OAUTH_REDIRECT_STATE_KEY } from 'app/constants';
import { OauthRedirectState } from 'app/services/auth/oauth-redirect.service';

@Injectable()
export class AppRedirectResolver {
    private translateService = inject(TranslateService);

    resolve(route: ActivatedRoute) {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const rawState = sessionStorage.getItem(OAUTH_REDIRECT_STATE_KEY);

        if (rawState && (code || error)) {
            let state: OauthRedirectState;
            try {
                state = JSON.parse(rawState) as OauthRedirectState;
            } catch {
                sessionStorage.removeItem(OAUTH_REDIRECT_STATE_KEY);
                state = null;
            }

            if (state) {
                const updated: OauthRedirectState = code
                    ? { ...state, code, oauthState: urlParams.get('state') ?? undefined }
                    : { ...state, error: error! };

                sessionStorage.setItem(OAUTH_REDIRECT_STATE_KEY, JSON.stringify(updated));
                window.location.href = window.location.origin + state.returnPath;
                return;
            }
        }

        let url = (route.data as any).externalUrl;
        const translatableUrl = (route.data as any).translatableUrl;

        if (translatableUrl) {
            url = this.translateService.instant(translatableUrl);
        }

        window.location.href = url;
    }
}
